import * as React from "react";
import CommonDeleteModal from "../../components/CustomDelete/CommonDeleteModal";
import { useRemoveRoleMutation } from "../../services/appln";
import strings from "../../config/localization";

export default function RoleRemove(props: any): any {
  const roleId = props.roleId;
  const userId = props.userId;

  const [removeRole, params] = useRemoveRoleMutation();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <CommonDeleteModal
        params={params}
        handleClickOpen={handleClickOpen}
        open={open}
        handleClose={handleClose}
        clickDeteleteApi={() => {
          removeRole({ userId: userId, roleId: roleId });
        }}
        deleteString={strings.remove}
        deleteTitle={strings.removeRoleTitle}
        deleteConfirmation={strings.removeRoleConfirmation}
        disagree={strings.disagree}
        agree={strings.agree}
      />
    </div>
  );
}
